export default __webpack_public_path__ + "static/media/alleyway.de78fe98.gif";